import { SET_TOUR_PROPS } from '../action-types';

export const setTourProps = props => ({
  type: SET_TOUR_PROPS,
  props,
});
